module.exports = __webpack_public_path__ + "img/20210903_101659.b6d560c8.jpg";